
// @ts-nocheck


export const localeCodes =  [
  "sk",
  "en"
]

export const localeLoaders = {
  "sk": [{ key: "../locales/sk-SK.json", load: () => import("../locales/sk-SK.json" /* webpackChunkName: "locale__opt_atlassian_pipelines_agent_build_locales_sk_SK_json" */), cache: true }],
  "en": [{ key: "../locales/en-US.json", load: () => import("../locales/en-US.json" /* webpackChunkName: "locale__opt_atlassian_pipelines_agent_build_locales_en_US_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "sk",
      "files": [
        "/opt/atlassian/pipelines/agent/build/locales/sk-SK.json"
      ]
    },
    {
      "code": "en",
      "files": [
        "/opt/atlassian/pipelines/agent/build/locales/en-US.json"
      ]
    }
  ],
  "defaultLocale": "sk",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "https://www.firemnereality.sk",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "sk",
    "files": [
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/sk-SK.json"
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/en-US.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
